// components/Form/NumberField.tsx
import { ChangeEvent } from 'react';
import { FormField } from './FormField';
 
type NumberFieldProps = {
  label?: string;
  value: number;
  onChange: (value: number) => void;
  error?: string;
  min?: number;
  max?: number;
  step?: number;
};
 
export const NumberField = ({
  label,
  value,
  onChange,
  error,
  min,
  max,
  step = 1
}: NumberFieldProps) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
	const newValue = parseFloat(e.target.value);
	if (!isNaN(newValue)) {
	  onChange(newValue);
	}
  };
 
  return (
	<FormField label={label} error={error}>
	  <input
		type="number"
		className="form-input-small"
		value={value}
		onChange={handleChange}
		min={min}
		max={max}
		step={step}
	  />
	</FormField>
  );
};